import { createApp } from 'vue';
import axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';
import { API_BASE, isNative } from './api/base';
import { armSplashFallback } from './native/splash';

// Design system de l'app mobile. Chaque règle y est préfixée par
// `body.is-native`, classe que seul Capacitor fait apparaître : la feuille est
// donc entièrement inerte sur le site web.
import './styles/mobile-app.css';

// Sur natif (iOS/Android), axios préfixe toutes les requêtes relatives avec www.ouicsport.fr.
// En web, API_BASE est vide → comportement actuel inchangé (proxy dev, même domaine prod).
if (API_BASE) {
  axios.defaults.baseURL = API_BASE;
}

// La classe est posée avant le montage, et non dans le mounted() de App.vue :
// sinon le shell natif s'affiche le temps d'une image sans ses styles, ce qui
// produit un sursaut visible au lancement.
if (isNative) {
  document.body.classList.add('is-native');
  // Également sur <html> : certaines corrections ne peuvent s'appliquer que
  // sur l'élément racine, notamment le blocage du défilement horizontal
  // (cf. l'iframe caché de Stripe dans styles/mobile-app.css).
  document.documentElement.classList.add('is-native');
}

// Filet de sécurité : si le montage échoue, le splash ne doit pas rester figé.
armSplashFallback();

createApp(App)
  .use(store)
  .use(router)
  .mount('#app');
